import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=0aa97f9e&scoped=true&"
import script from "./LayoutHeader.vue?vue&type=script&lang=ts&"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=0aa97f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa97f9e",
  null
  
)

export default component.exports